import { Actions, thunk } from 'easy-peasy';

import api from '~/services/api';
import { IAiAssistActions, IThunkOnNoteAssist } from '../types';

const onGetAIAssist: IThunkOnNoteAssist = thunk(
  async ({ setNoteAssist }: Actions<IAiAssistActions>, payload) => {
    const { data } = await api.aiAssist.getNoteAssist({
      clinicId: payload.clinicId,
      data: payload.data,
    });
    setNoteAssist(data?.result);
  },
);

export default onGetAIAssist;
